<template>
  <div class="home">
    
    <div class="container" id="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="input-group">
                        <span class="input-group-text">标题</span>
                        <input v-model="diary.title" class="form-control"  placeholder="简要说明"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="input-group">
                        <span class="input-group-text">内容</span>
                        <textarea @blur="OnBlur" @paste="handlePaste($event)" v-model="diary.content" rows="16" class="form-control" placeholder="具体内容"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 label-group">
                    <span style="margin:0 10px 15px 10px;"
                      v-for="(tag,index) in tags" 
                      :key="index" class="badge" 
                      :class="[tag.check ? 'bg-success' : 'bg-secondary']" 
                      @click="tag.check=!tag.check">{{tag.name}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center" >
                    <span class="btn btn-primary form-control"
                    @click='SubmitDiary'>{{operName}}</span>
                </div>

                <div class="col-md-12 text-center" v-if="showUpload" >
                    <br>
                    <span class="btn btn-link" @click='UploadFile'>上传图片视频</span>
                    <input type="file" accept="image/*,video/mp4" style="display:none;" @change="DoChange($event)" ref="fileInput">
                    <span v-for="htmlType in htmlTypes" v-bind:key="htmlType.type" class="btn btn-link" @click='InsertHtml(htmlType.content)'>插入{{ htmlType.type }}</span>
                </div>
            </div>
                <!-- 粘贴文件预览弹窗 -->
                <div v-if="showPastedPreview" class="pasted-preview-backdrop" @click.self="cancelPasted">
                  <div class="pasted-preview-dialog">
                    <h5>粘贴文件预览</h5>
                    <div class="preview-body">
                      <img v-if="pastedFile && pastedFile.type.indexOf('image/') === 0" :src="pastedPreviewUrl" alt="预览图片" />
                      <video v-else-if="pastedFile && pastedFile.type.indexOf('video/') === 0" :src="pastedPreviewUrl" controls></video>
                      <div v-else class="file-info">
                        <p class="mb-1">{{ pastedFileName }}</p>
                        <p class="text-muted">{{ pastedFileType }}</p>
                      </div>
                    </div>
                    <div class="preview-actions mt-2 text-end">
                      <button class="btn btn-primary" @click="confirmUploadPasted">上传</button>
                      <button class="btn btn-secondary ms-2" @click="cancelPasted">取消</button>
                    </div>
                  </div>
                </div>
        </div>
  </div>
</template>

<style scoped lang="less">
  .label-group {
    span{
      cursor: pointer;
      margin:0px 10px;
    }
  }
  
</style>

<style scoped>
  .pasted-preview-backdrop{
    position:fixed;
    left:0;right:0;top:0;bottom:0;
    background:rgba(0,0,0,0.4);
    display:flex;
    align-items:center;
    justify-content:center;
    z-index:2000;
  }
  .pasted-preview-dialog{
    background:#fff;
    padding:12px;
    border-radius:8px;
    max-width:90vw;
    width:520px;
    box-shadow:0 6px 24px rgba(0,0,0,0.2);
  }
  .pasted-preview-dialog img{max-width:100%;max-height:60vh;display:block;margin:0 auto}
  .pasted-preview-dialog video{max-width:100%;max-height:60vh;display:block;margin:0 auto}
  .file-info{padding:8px}
</style>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/Default.vue'
//import qs from 'qs'


export default {
  name: 'Home',
  data() {
    return {
      //日志
      diary:{
        "title":'',
        "content":'',
        "tags":'',
        "addUser":'',
        "status":0
      },
      //当前光标位置
      cursorPosition:0,
      //配置文件位置
      filePath:'/image/init.txt',
      //html类型
      htmlTypes:[],
      //日志标签
      tags: [],
      //是否显示上传图片按钮，如果有DiaryId则显示，否指不显示
      showUpload:false,
      operName:'添加',
      // 粘贴文件相关
      pastedFile: null,
      pastedPreviewUrl: '',
      showPastedPreview: false
    }
  },
  methods:{
    // 处理粘贴事件
    handlePaste(e) {
      try {
        const clipboard = e.clipboardData || window.clipboardData;
        if (!clipboard) return;

        const items = clipboard.items || [];
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.kind === 'file') {
            const file = item.getAsFile();
            if (file) {
              this.pastedFile = file;
              this.pastedPreviewUrl = URL.createObjectURL(file);
              this.showPastedPreview = true;
              // 阻止默认把图片作为文本插入
              e.preventDefault();
              return;
            }
          }
        }
      } catch (err) {
        console.error('handlePaste error:', err);
      }
    },

    // 取消粘贴预览并释放资源
    cancelPasted() {
      if (this.pastedPreviewUrl) {
        try { URL.revokeObjectURL(this.pastedPreviewUrl); } catch (e) {}
      }
      this.pastedFile = null;
      this.pastedPreviewUrl = '';
      this.showPastedPreview = false;
    },

    // 上传粘贴的文件并插入相应 HTML
    confirmUploadPasted() {
      const that = this;
      if (!this.pastedFile) return;

      const file = this.pastedFile;
      const formData = new FormData();
      formData.append('file', file);

      const options = {
        method: 'POST',
        headers: { "Content-Type": "multipart/form-data" },
        dataType: 'json',
        data: formData,
        url: '/api/MyDiary/Upload'
      };

      that.$myAxios(that, options, res => {
        if (res.description) {
          const url = res.description;
          if (file.type.indexOf('video/') === 0) {
            that.InsertHtml("<video controls style='max-width:70vw;max-height:40vh' src='" + url + "'></video>");
          } else if (file.type.indexOf('image/') === 0) {
            that.InsertHtml("<img style='max-width:70vw;max-height:40vh' src='" + url + "'></img>");
          } else {
            that.InsertHtml("<a href='" + url + "' target='_blank'>" + (that.pastedFile.name || '下载文件') + "</a>");
          }
          that.cancelPasted();
        }
      }, true);
    },
    SubmitDiary:function(){
      var that = this;
      if(this.diary.title==''||this.diary.content==''||this.diary.tags=='')
      {
        that.$toast('请填写标题、内容并选择标签','fail')
        return;
      }
      const options = {
        method: 'POST',
        headers: { "Content-Type": "application/json"},
        //headers: { 'content-type': 'application/x-www-form-urlencoded' },
        //headers: { 'content-type': 'text/plain' },
        //data: qs.stringify(param),   // 用 qs 将js对象转换为字符串 
        dataType:'json',
        data:JSON.stringify(this.diary),
        url:'/api/MyDiary/Add'
        //url: 'devhost/MyDiary/AddDiary'
      }; 

      that.$myAxios(that,options,res=>{
        that.$toast(res.msg,'succ');
        if(res.description){
          that.diary = res.description;
          that.showUpload = true;
          that.operName = '修改';
        }
      })
    },
    OnBlur(e) {
      this.cursorPosition = e.srcElement.selectionStart;
    },
    // 插入内容
    InsertHtml(val) {
      val = "\r\n"+val;
      let num = this.cursorPosition
      let type = typeof num
      let cont = this.diary.content
      if (type == "number") {//插入到指定光标处
        let right = cont.slice(0, num)
        let left = cont.slice(num)
        this.diary.content = right + val + left
      } else {//没有指定插入直接添加到最后
        this.diary.content += val;
      }
    },
    UploadFile(){
        this.$refs.fileInput.click();
    },
    DoChange(e)
    {
      var that = this;
      var file = e.target.files[0];
      var fileType = file.type;
      //清空
      e.target.value='';
      const formData = new FormData();  
      formData.append('file', file); 
      const options = {
        method: 'POST',
        headers: {  "Content-Type": "multipart/form-data"},
        //headers: { "Content-Type": "application/json"},
        //headers: { 'content-type': 'application/x-www-form-urlencoded' },
        //headers: { 'content-type': 'text/plain' },
        //data: qs.stringify(param),   // 用 qs 将js对象转换为字符串 
        dataType:'json',
        data:formData,
        url:'/api/MyDiary/Upload'
        //url: 'devhost/MyDiary/AddDiary'
      }; 

      that.$myAxios(that,options,res=>{
        if(res.description){
          if(fileType=='video/mp4'){
            that.InsertHtml("<video controls style='max-width:70vw;max-height:40vh' src='"+res.description+"'></video>")
          }
          else{
            that.InsertHtml("<img style='max-width:70vw;max-height:40vh' src='"+res.description+"'></img>")
          }
        }
      },true)
    },
  },
  mounted(){
    var user = this.$cookies.get('username');
    if(!user){
      this.$router.push('/login');
      return;
    }
    this.diary.addUser=user;
    var that = this;
    var diaryID = this.$route.query.id;
    
    //console.log(diaryID);
    //如果有参数，载入数据
    if(diaryID&&diaryID!=''){
      that.showUpload = true;
      that.operName = '修改';
      that.$myAxios(that,
      {
        method: 'GET',
        url:'/api/MyDiary/GetByID?id='+diaryID,
      }
      ,res=>{
        that.diary = res.description;
        //处理标签
        var tagArr = that.diary.tags.split(',');
        tagArr.forEach(tagVal=>{
          var hasTag = false;
          that.tags.forEach(tag=>{
            if(tag.name==tagVal)
            {
              hasTag = true;
              tag.check=true;
            }
          })
          if(!hasTag)
          {
            that.tags.push({name:tagVal,check:true});
          }
        })
      })
    }
    //如果没参数，获取临时数据
    else if(sessionStorage.getItem('tempdata-Home'))
    {
      try{
        var tempData = JSON.parse(sessionStorage.getItem('tempdata-Home'));
        var keys = Object.keys(that.$data);
        keys.forEach(key=>{
          if(tempData[key])
          {
            that[key] = tempData[key];
          }
        })
      }
      catch(err)
      {
        console.log('错误：',err)
      }
      sessionStorage.removeItem('tempdata-Home');
    }

    const optionsTxt = {
        method: 'GET',
        //headers: { "Content-Type": "application/json"},
        //headers: { 'content-type': 'application/x-www-form-urlencoded' },
        //headers: { 'content-type': 'text/plain' },
        //data: qs.stringify(param),   // 用 qs 将js对象转换为字符串 
        dataType:'json',
        //data:JSON.stringify(this.diary),
        url:that.filePath,
        //url: 'devhost/MyDiary/AddDiary'
      }; 

      that.$myAxios(that,optionsTxt,res=>{
        console.log(res);
        that.htmlTypes=res.htmlTypes;
        that.tags=res.tags;
      })
  },
  computed: {
    pastedFileName() {
      return this.pastedFile ? this.pastedFile.name : '';
    },
    pastedFileType() {
      return this.pastedFile ? this.pastedFile.type : '';
    }
  },
  watch:{
    //监控标签变化
    tags:{
      handler(newTags,oldTags)
      {
        var tagsVal = '';
        newTags.forEach(tag => {
          if(tag.check)
          {
            if(tagsVal!='')
            {
              tagsVal += ',';
            }
            tagsVal += tag.name;
          }
        });
        this.diary.tags = tagsVal;
      },
      immediate:true,
      deep:true
    }
  }
  // components: {
  //   HelloWorld
  // }
}
</script>
